<template>
		<section class="knd-eindscherm">
			<div class="knd-container">
				<article>
					<div v-html="$store.getters.landing.outro"></div>
				</article>
			</div>

			<div class='knd-colofon'>
				<div class="knd-container">
					<article>
						<div v-html="$store.getters.landing.colofon"></div>
					</article>
				</div>
			</div>
		</section>

</template>

<script>

export default {
  name: 'eindscherm',
	components: {},
  data () {
    return {

    }
  },
	mounted: function() {
		
	},
  methods: {

  } 
}
</script>